import {
  AutoComplete,
  Avatar,
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getImgUrl, getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import AddMerchant from "./AddMerchant";
import {
  CheckOutlined,
  CloseOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import moment from "moment";
const { RangePicker } = DatePicker;

const MerchantsList = () => {
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [status, setStatus] = useState("");
  const [merchantType, setMerchantType] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [visible, setVisible] = useState(undefined);
  const [key, setKey] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(undefined);
  const [selectedMerchant, setSelectedMerchant] = useState(undefined);
  const [selectedMerchantForEdit, setSelectedMerchantForEdit] =
    useState(undefined);

  const [range, setRange] = useState<any>({
    from: null,
    to: null,
  });

  const [merchantData, setMerchantData] = useState<any>({
    loading: false,
    data: null,
  });

  const [merchantOptions, setMerchantOptions] = useState({
    loading: false,
    list: [],
  });

  const [typeOptions, setTypeOptions] = useState<any>({
    loading: false,
    list: [],
  });

  const getMerchants = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();
    setMerchantData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/merchant/all?page=0&limit=20` +
          (key ? `&nameOrMobileNumber=${key}` : ``) +
          (from ? `&startAt=${from}` : ``) +
          (to ? `&endAt=${to}` : ``),
        // (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setMerchantData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setMerchantData({ loading: false, data: [] });
        console.error("Merchant: Error", err);
      });
  }, [page, limit, key, type, range]);

  const getMerchantsOptions = useCallback(
    async (key?: string) => {
      setMerchantOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
      const res = await axios.get(
        `${encodedUri}/admin/merchant/all?page=0&limit=20` +
          (key ? `&nameOrMobileNumber=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setMerchantOptions({
        loading: false,
        list: res.data?.merchants?.map((merchant) => ({
          label: `${
            merchant?.fullName?.toUpperCase() ||
            merchant?.merchantPersonalDetail?.name?.toUpperCase()
          } - ${merchant?.mobileNumber?.replace("+88", "")}`,
          value: merchant?.mobileNumber?.replace("+88", ""),
        })),
      });
    },
    [type]
  );
  const getMerchantType = useCallback(async (key?: string) => {
    setTypeOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    const res = await axios.get(`${encodedUri}/merchant/type`, {
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
      },
    });

    setTypeOptions({
      loading: false,
      list: res.data?.merchantTypes?.map((type: { name: any; id: any }) => ({
        label: type.name,
        value: type.name?.toUpperCase(),
      })),
    });
  }, []); 

  useEffect(() => {
    getMerchants();
    getMerchantsOptions();
    getMerchantType();
  }, [getMerchants, getMerchantsOptions, getMerchantType]);

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    setMerchantType("");
    setRange({
      from: null,
      to: null,
    });
    form.resetFields();
  };

  useEffect(() => {
    if (visible) {
      setSelectedMerchant(undefined);
      setSelectedMerchantForEdit(undefined);
    }
  }, [selectedMerchant, selectedMerchantForEdit, visible]);

  useEffect(() => {
    setSelectedMerchant(undefined);
    setSelectedMerchantForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedMerchant(null);
    setSelectedMerchantForEdit(null);
    getMerchants();
  };

  const fetchRef = useRef(0);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "merchant") getMerchantsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getMerchantsOptions]);

  return (
    <React.Fragment>
      <TopHeading
        total={merchantData?.data?.totalElements}
        refetch={getMerchants}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          {/* <Form.Item initialValue={type}>
            <Select
              placeholder="Type"
              onChange={(val) => setType(val)}
              value={type}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item> */}
          <Form.Item name="area" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "merchant")}
              onSelect={(val) => setKey(val)}
              options={merchantOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                merchantOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ minWidth: 300 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => {
                  setKey(val);
                }}
                enterButton
                loading={merchantOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>
          <Form.Item name="type_search">
            <Select
              allowClear
              placeholder="Filter by Type"
              optionFilterProp="children"
              onChange={(val) => setMerchantType(val)}
              filterOption={() => {
                return true;
              }}
              options={typeOptions.list}
            ></Select>
          </Form.Item>
          <Form.Item name="range">
            <RangePicker
              defaultValue={
                range.from != null && range.to != null
                  ? [moment(range.from), moment(range.to)]
                  : null
              }
              onChange={(e, f) => {
                console.log("momnet", moment.utc(f[0])?.toISOString());
                setRange({ from: f?.[0], to: f?.[1] });
              }}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  moment("00:00:00", "HH:mm:ss"),
                  moment("23:59:59", "HH:mm:ss"),
                ],
              }}
              inputReadOnly
              allowClear
            />
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Merchant</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Created Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {merchantData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {merchantData?.data?.merchants?.length ? (
                    merchantData?.data?.merchants?.map(
                      (merchant: any, index: any) => (
                        <React.Fragment key={index}>
                          <Link to={`/merchants/${merchant?.id}/details`}>
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <Avatar
                                  shape="circle"
                                  size={45}
                                  src={getImgUrl(
                                    merchant?.merchantPersonalDetail
                                      ?.profilePicture
                                  )}
                                  className="mr-3"
                                />
                                <span className="name">
                                  {merchant?.name?.toUpperCase()} <br />
                                  {merchant?.mobileNumber?.split("+88")}
                                </span>
                              </div>{" "}
                              <div className="single-product">
                                <span className="name">
                                  {merchant?.type?.replace("_", " ")}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  <small>
                                    {moment(merchant?.createdAt).fromNow()}
                                  </small>
                                  <br />
                                  <span className="name">
                                    {moment(merchant?.createdAt).format("lll")}
                                  </span>
                                </span>
                              </div>
                              <div className="single-product">
                                <span
                                  className={`d-flex align-items-center radius-btn text-uppercase ${merchant?.status?.toLowerCase()}-btn`}
                                >
                                  {merchant?.status?.toUpperCase() ===
                                  "OPEN" ? (
                                    <CheckOutlined className="mr-1" />
                                  ) : merchant?.status?.toUpperCase() ===
                                    "BUSY" ? (
                                    <WarningOutlined className="mr-1" />
                                  ) : (
                                    <CloseOutlined className="mr-1" />
                                  )}
                                  {merchant?.status?.split("_").join(" ")}
                                </span>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Merchants" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={"Edit Merchant"}
            width={600}
            onClose={() => {
              setSelectedMerchant(null);
              setSelectedMerchantForEdit(null);
            }}
            visible={selectedMerchant || selectedMerchantForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedMerchantForEdit ? (
              <AddMerchant
                // merchantId={selectedMerchantForEdit}
                onCloseMethod={onClose}
                visibleData={selectedMerchantForEdit}
              />
            ) : undefined}
          </Drawer>

          <PaginationTwo
            {...merchantData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default MerchantsList;
